import React, { useState } from "react";
import classNames from "classnames/bind";
import { SearchBlack } from "../../../../components/Icons/Icons";
import { SelectBox, SelectBoxItem } from "../../../../components";
import useFetchData from "../../../../hooks/useFetchData";
import styles from "./ModalCamera.module.css";

const cx = classNames.bind(styles);
const Filter = ({
  onChangeProvince,
  onChangeTexSearch,
  onChangeDistrict,
  onChangeCommune,
  onChangeStatus }) => {
  const [provinceCode, setProvinceCode] = useState({ code: null, name: "" });
  const [districtCode, setDistrictCode] = useState({ code: null, name: '' });
  const [text, setText] = useState('');

  const province = useFetchData("province/get-info-province/", {
    nation_code: "VNM",
  });
  const district = useFetchData(
    `district/get-list-district/?province_code=${provinceCode.code}`
  );
  const commune = useFetchData(
    `/commune/get-list-commune/?district_code=${districtCode.code}`
  )

  const handleChangeProvince = (data) => {
    setProvinceCode({ code: data })
    onChangeProvince(data)
  }

  const handleChangeStatus = (data) => {
    onChangeStatus(data)
  }

  const handleChangeDistrict = (data) => {
    setDistrictCode({ code: data })
    onChangeDistrict(data)
  }

  const handleChangeCommune = (data) => {
    onChangeCommune(data)
  }

  const handleChangeTextSearch = (value) => {
    setText(value)
    onChangeTexSearch(value)
  }

  return (
    <div className={cx("filter")}>
      <div className={cx("search")}>
        <input className={cx("search-input")} value={text} placeholder="Tìm kiếm..." onChange={(e) => handleChangeTextSearch(e.target.value)} />
        <span className={cx("icon-search")}>
          <SearchBlack />
        </span>
      </div>
      <div>
        <label className={cx("label")}>Tỉnh</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={handleChangeProvince}
        >
          {province.data &&
            province.data.map((item, index) => (
              <SelectBoxItem
                label={item.PROVINCE_NAME}
                value={item.PROVINCE_CODE}
                key={index}
              />
            ))}
        </SelectBox>
      </div>

      <div>
        <label className={cx("label")}>Huyện</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={handleChangeDistrict}
        >
          {district.data &&
            district.data.map((item, index) => (
              <SelectBoxItem
                label={item.DISTRICT_NAME}
                value={item.DISTRICT_CODE}
                key={index}
              />
            ))}
        </SelectBox>
      </div>
      <div>
        <label className={cx("label")}>Xã</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={handleChangeCommune}
        >
          {commune.data &&
            commune.data.map((item, index) => (
              <SelectBoxItem
                label={item.COMMUNE_NAME}
                value={item.COMMUNE_CODE}
                key={index}
              />
            ))}
        </SelectBox>
      </div>
      <div>
        <label className={cx("label")}>Trạng thái</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={handleChangeStatus}
        >
          <SelectBoxItem label="Tất cả" value="all" />
          <SelectBoxItem label="Đang trực tuyến" value= {'["0"]'} />
          <SelectBoxItem label="Mất kết nối" value={'["1", "2"]'}/>
          <SelectBoxItem label="Sẵn sàng" value={'["3"]'} />
        </SelectBox>
      </div>
    </div>
  );
};

export default Filter;
